import React, { useEffect, useContext } from "react";
import PropTypes from "prop-types";
import _, { xor } from "lodash";
import { buildVariantCloseStylesheet } from "./VariantCloseStyleResolver";

const VariantClose = (props) => {
  const cta = props.cta;
  const variant = props.variant;
  const step = props.step;

  const stylesheet = buildVariantCloseStylesheet(
    props.builder,
    props.device,
    props.cta,
    variant
  );

  let iconThickness = variant.options["close-icon-thickness"]
    ? variant.options["close-icon-thickness"]
    : "thick";

  let iconColor = variant.options["close-icon-color"]
    ? variant.options["close-icon-color"]
    : "#676f84";

  const openSettings = () => {
    dispatchCustomEvent("panelView", {
      view: "theme",
      collapse: "Close Icon",
    });
  };

  return (
    <React.Fragment>
      <div
        className="cf-close"
        data-cta-id={cta.id}
        onClick={openSettings}
        role="button"
        tabIndex={0}
        aria-label="Close popup"
      >
        {iconThickness == "thick" && (
          <svg
            fill={iconColor}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 30"
          >
            {" "}
            <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z" />
          </svg>
        )}
        {iconThickness == "thin" && (
          <svg
            fill={iconColor}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z" />
          </svg>
        )}
      </div>
      <style dangerouslySetInnerHTML={{ __html: stylesheet }} />
    </React.Fragment>
  );
};

export default VariantClose;
